import React, {FunctionComponent, useEffect} from 'react'
import 'react-calendar/dist/Calendar.css';
import {Slot} from '@App/types'
import {useSlots} from "@App/hooks/useSlots";
import {Loader} from "@App/components/common/Loader";
import {isSameDay, parseISO} from "date-fns";
import {Text} from "@eo-locale/react";

type TimeSlotPickerProps = {
    onChange: (event: Slot) => void
    onChangeEarliestSlot?: (event: Slot) => void
    className?: string
    daysLoading?: boolean
    day: Date
    selectedSlot?: Slot
}

export const TimeSlotPicker: FunctionComponent<TimeSlotPickerProps> = (props: TimeSlotPickerProps) => {
    const {loading, nextSlot, slots, error} = useSlots(props.day)

    useEffect(() => {
        if (slots && slots.length > 0 && !props.selectedSlot) {
            props.onChange(slots[0])
        }
        if (slots && slots.length > 0 && props.selectedSlot && !isSameDay(parseISO(props.selectedSlot.starts_at), parseISO(slots[0].starts_at))) {
            props.onChange(slots[0])
        }
        nextSlot && props.onChangeEarliestSlot && props.onChangeEarliestSlot(nextSlot)
    }, [loading, slots, nextSlot, error])

    if (error) {
        //console.log(error)
    }

    return (
        <div className={'relative max-h-[250px]'}>
            <div
                className={`
                max-h-[240px]
                flex flex-col
                sm:text-sm
                bg-white
                border border-gray-300 rounded-lg
                p-3
                w-full
            ${(loading || props.daysLoading) ? 'blur-sm animate-pulse opacity-90' : ''}`}>
                <p>Verfügbare Abgabezeit</p>
                <div
                    className={'grid grid-cols-2 gap-2 mt-3 overflow-y-auto no-scrollbar'}>
                    {error && (
                        <div><Text id={'error'}/></div>
                    )}
                    {(loading || props.daysLoading) && (
                        <>
                            <span className="w-full rounded border opacity-50 h-7 rounded-md"/>
                            <span className="w-full rounded border opacity-50 h-7 rounded-md"/>
                            <span className="w-full rounded border opacity-50 h-7 rounded-md"/>
                            <span className="w-full rounded border opacity-50 h-7 rounded-md"/>
                            <span className="w-full rounded border opacity-50 h-7 rounded-md"/>
                            <span className="w-full rounded border opacity-50 h-7 rounded-md"/>
                            <span className="w-full rounded border opacity-50 h-7 rounded-md"/>
                        </>
                    )}
                    {!loading && !props.daysLoading && !error && props.selectedSlot && slots && slots.length > 0 && slots.map((slot) => (
                        <span
                            className={`
                        text-center hover:text-white
                        rounded
                        py-1 px-3
                        hover:bg-primary-200
                        cursor-pointer
                        border hover:border-primary
                        ${slot.starts_at === props.selectedSlot?.starts_at
                                ? 'bg-primary border-primary text-white'
                                : 'text-primary border-gray-400'}`}
                            onClick={() => props.onChange(slot)}
                            key={slot.starts_at}>{slot.starts_at.slice(11, 16)}</span>
                    ))}
                </div>
            </div>
            {(loading || props.daysLoading) && (
                <div
                    className={'absolute top-1/3 text-2xl font-serif text-center w-full'}>
                    <Loader loaderSizeClass={'w-24 h-24'} logoSizeClass={'w-12 h-12'}/>
                </div>
            )}
        </div>
    )
}
